import { LazyLoadImage } from "react-lazy-load-image-component";
import m from "../../Images/m.png";
import syria from "../../Images/syria.png";

function TwoColCampaign() {
  return (
    <div className="w-full bg-white py-4 md:py-6 lg:py-8">
      <div className="container max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-4">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-5 lg:gap-6 overflow-hidden">
          <div className="relative group overflow-hidden rounded-xl sm:rounded-2xl md:rounded-[15px] shadow-md hover:shadow-xl transition-all duration-500">
            <LazyLoadImage
              className="w-full h-48 xs:h-56 sm:h-64 md:h-72 lg:h-80 xl:h-96 object-cover group-hover:scale-105 transition-transform duration-700"
              src={m}
              alt="Morocco Campaign"
              effect="opacity"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="absolute bottom-0 right-0 left-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
              <h3 className="text-lg font-bold text-right">حملة المغرب</h3>
            </div>
          </div>

          <div className="relative group overflow-hidden rounded-xl sm:rounded-2xl md:rounded-[15px] shadow-md hover:shadow-xl transition-all duration-500">
            <LazyLoadImage
              className="w-full h-48 xs:h-56 sm:h-64 md:h-72 lg:h-80 xl:h-96 object-cover group-hover:scale-105 transition-transform duration-700"
              src={syria}
              alt="Syria Campaign"
              effect="opacity"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="absolute bottom-0 right-0 left-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
              <h3 className="text-lg font-bold text-right">حملة سوريا</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwoColCampaign;
